import { render, staticRenderFns } from "./AttachProductsToDeviceDialog.vue?vue&type=template&id=32bf4d9e"
import script from "./AttachProductsToDeviceDialog.vue?vue&type=script&lang=js"
export * from "./AttachProductsToDeviceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports